
import { ADPLogHeaderType, DeliveryModes, DiagnosticDataTransferReq} from '@npd-ng/adp-types';
import { fetchService } from './fetchService';
import { environment ,getDeviceType,getPlatformFromUserAgent,HEADER_ENAEP, NOT_APPLICABLE, NOT_AVAILABLE} from '../util';
import { IADPState } from '../typings';
const logPrefix = "[ADP Student App][DeviceValidationLogHandler]"
export const DeviceValidationLogHandler = (props:{dataTransferUrl:string,putHeader:any})=>{
  const fetch = fetchService;
  const constructDeviceValidationDataTransferPayload= (appState:IADPState,fileName?:string)=>{
    const payload: DiagnosticDataTransferReq = {
      deliveryType: appState.sessionState.selectedAssessmentMode as DeliveryModes,
      dataType:"DIAGNOSTIC",
      taskType: "UPLOAD",
      taskMessage: "Post validation logs",
      dataSubCategory: "device-validation",
      data: {
        fileName: fileName ||`${appState.appState.appLaunchId}.device-validation.json`,
      },
      clientDetails: {
        ip: "127.0.0.1",
        appName: `ng-enaep-student-app/${appState.deviceState.deviceType?.toLocaleLowerCase()}/p1`,
        deviceDetails: {
          deviceType: getDeviceType() as "NPE", //workaround for invalid typing in the @npd-ng/adp-types
          deviceName: appState.deviceState.deviceId || NOT_AVAILABLE,
          deviceModel: appState.deviceState.deviceModel ||  NOT_AVAILABLE,
          operatingSystem: getPlatformFromUserAgent()
        } as DiagnosticDataTransferReq["clientDetails"]["deviceDetails"],
      },
    };
    const logHeader:ADPLogHeaderType = {
      "schemaVersion": "3.0.2",
      "releaseVersion": appState.appState?.releaseVersion || "NotAvailable",
      "buildNumber": appState.appState?.releaseBuildNumber.toString() || "NotAvailable",
      "appVersion": appState.appState.appVersion,
      "appType": "ng-enaep-student-app",
      "appName": "ng-enaep-adp-pwa",
      "deviceDetails": {
        "deviceType": appState.deviceState.deviceType,
        "deviceName": appState?.deviceState?.deviceId || "NotAvailable",
        "deviceModel": appState?.deviceState?.deviceModel || "NotAvailable",
        "hostingPlatform": appState.appState.runtimePlatform,
        "operatingSystem": getPlatformFromUserAgent()
      },
      "sessionDetails": {
        "clientLaunchId":  appState.appState?.appLaunchId || "NotAvailable",
        "adpLaunchDateTime":  new Date(appState.appState?.appLaunchTime),
        "setupCode": appState.sessionState.schoolDetails?.setupCode || NOT_APPLICABLE,
        "verificationCode": appState.sessionState.schoolDetails?.verificationCode || NOT_APPLICABLE,
        "appAccessedFor": appState.sessionState.appAccessedFor,
        "participantId": NOT_AVAILABLE,
        "assessmentDeliveryMode": appState.sessionState.selectedAssessmentMode,
        "serverDetails": environment.resolveApiDomain(appState.appState.configuration),
        "connectionType":appState?.deviceState?.deviceType === "SBE" ? "Internet" : "NPN"
      }
    }
    return {payload,logHeader};
  }
  /**
   * 
   * @param appState 
   * @param fileName 
   * @param data 
   * @returns Promise
   * If playload and logHeader undefined, construct the request from current app state values
   * Logs that stored from previous sessions shall come with predefined payload and logHeader
   */
  const postValidationLogs= (appState:IADPState,fileName:string,data?: 
    {payload:DiagnosticDataTransferReq,logHeader:any,deviceValidationChecks:any})=> new Promise<boolean>((resolve)=>{
    const _getRequestPayload=()=>{
      if(!data){
          const {payload,logHeader} = constructDeviceValidationDataTransferPayload(appState,fileName);
          return {
              payload:payload,
              logHeader:logHeader,
              deviceValidationChecks:
              {
              ...appState.deviceReadinessState.deviceReadinessInfo,
              responses:appState.deviceReadinessSummary?.responses,
              status:appState?.deviceReadinessSummary?.status,
              }
            }
      }
      else{
          return {
            ...data
          }
      }
    }
    const {deviceValidationChecks, logHeader,payload}  = _getRequestPayload();
    const getSignedUrl=(url:string, payload:DiagnosticDataTransferReq,cb: any)=>{
      fetch(url,{method:'POST',headers:HEADER_ENAEP,body:JSON.stringify(payload)})
      .then(async(response: any) => {
        if(response.status === 200) {
          const data = await response.json()
          cb(data.dataUri)
        }
      }).catch((e:any) => {
        console.error(logPrefix,`[getSignedUrl not available: ${JSON.stringify(e)}`);
        cb(false)
      })
    }
    const onSignedUrl = async (response:any)=>{
      if(response){
          const payload = {...logHeader,deviceValidationChecks:deviceValidationChecks}
          fetch(response,{method:'PUT',headers:props.putHeader,body:JSON.stringify(payload)})
          .then(()=>{
          resolve(true);
        }).catch((err:any)=>{
          console.error(logPrefix,"An error occurred trying to send the device validation log.",err);
          resolve(false)
        })
      }
      else{
        resolve(false);
      }
    };
  let url= props.dataTransferUrl
  if(url && url !== "")getSignedUrl(url,payload,onSignedUrl);
  else{
    resolve(false)
  }
  }) 
 return {postValidationLogs,constructDeviceValidationDataTransferPayload}
}



